<template>
	<div>
		<Header></Header>
		<loginheader flagg="0" num="1"></loginheader>
		<div class="noresult" @click.stop="back">
			<div class="noresult-con1">
				<router-view />
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import searchzj from "../searchzj.vue";
	import loginheader from "../loginheader.vue";
	import Header from "../Header.vue";
	import Fotter from "../Fotter.vue";
	export default {
		name: "App",
		props: ["flag"],
		components: {
			Header,
			loginheader,
			Fotter,
			searchzj
		},
		beforeCreate() {},
		methods: {
			back() {
				this.$router.push("/index");
			}
		}
	};
</script>

<style>
	.noresult {
		width: 100%;
	}
	.noresult-dw {
		width: 100%;
		height: 174px;
		display: flex;
		justify-content: center;
		position: relative;
	}
	.noresult-con1 {
		width: 1200px;
		display: flex;
		justify-content: center;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/Noresult.vue